"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Avatar;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/avatar/index.css");

  require("../../spectrum-css/avatar/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/avatar/index-lg.css");
} else {
  require("../../spectrum-css/avatar/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/avatar/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/avatar/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/avatar/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/avatar/multiStops/darkest.css");

function Avatar(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["src", "alt", "disabled", "className"]);
  className = (0, _classnames["default"])('spectrum-Avatar', {
    'is-disabled': disabled
  }, className);
  return _react["default"].createElement("img", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
    src: src,
    alt: alt,
    className: className
  }));
}

Avatar.propTypes = {
  /**
   * url of image to load, same that any html <img> tag would accept
   */
  src: _propTypes["default"].string,

  /**
   * alt text to display for screen readers or if the image doesn't load
   */
  alt: _propTypes["default"].string,

  /**
   * Greys out the avatar
   */
  disabled: _propTypes["default"].bool,

  /**
   * String of custom class names to add to the top level dom element of Avatar
   */
  className: _propTypes["default"].string
};
Avatar.defaultProps = {
  alt: ''
};